/*自定义单页
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    infoDataApi: (data) => axios.get(`/api/api/customize-page/${data}`),
}